import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '../../components/Button/Button';
import { QuestionIcon } from '../../components/Icon/Icon';
import Tooltip from '../../components/Tooltip/Tooltip';
import { RoutesPathE } from '../../declarations/enums/routes';
import useReactRouter from '../../hooks/useReactRouter';
import {
  FeedbackWrapperStyled,
  ImageStyled,
  InnerWrapperStyled,
  ThankYouDescriptionStyled,
  ThankYouPageWrapperStyled,
  TitleStyled,
} from './ThankYouPage.styled';

const ThankYouPage: React.FC = () => {
  const { navigateTo } = useReactRouter();

  const onCalculateAgain = () => {
    navigateTo(RoutesPathE.HOME_PAGE);
  };

  return (
    <ThankYouPageWrapperStyled>
      <InnerWrapperStyled>
        <TitleStyled>
          <FormattedMessage
            id="thankYou.page.title"
            defaultMessage="Thank you for making the right choice for the future of our planet!"
          />
        </TitleStyled>

        <ThankYouDescriptionStyled>
          <FormattedMessage
            id="thankYou.page.text"
            defaultMessage="Your payment is being processed and you will receive a copy of your order once it is
            finalized. You will also receive the Certificate(s) of Emission Reduction in a separate
            email."
          />
        </ThankYouDescriptionStyled>

        <ImageStyled src="/images/thank-you.png" alt="Thank you tree" />

        <Button onClick={onCalculateAgain} isInverted>
          <FormattedMessage id="button.calculateAgain" defaultMessage="Calculate again" />
        </Button>

        <FeedbackWrapperStyled>
          <a href="mailto:contact@wayaj.com">
            <FormattedMessage id="common.giveFeedback" defaultMessage="Give feedback" />
          </a>

          <Tooltip element={<QuestionIcon />}>
            <FormattedMessage
              id="giveFeedBack.tooltip.text"
              defaultMessage="Did you encounter any problems or anything was not clear? Help us improve. We are a young company and your opinion counts!"
            />
          </Tooltip>
        </FeedbackWrapperStyled>
      </InnerWrapperStyled>
    </ThankYouPageWrapperStyled>
  );
};

export default ThankYouPage;
